import { render, staticRenderFns } from "./RestaurantePrintQueueWorker.vue?vue&type=template&id=64b4df94"
import script from "./RestaurantePrintQueueWorker.vue?vue&type=script&lang=js"
export * from "./RestaurantePrintQueueWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports